import { getDescription, getPublishTime } from './utils';
import { NotificationStepsProps } from '../NotificationForm';
import { Flex, Text, VStack, Grid, GridItem } from '@chakra-ui/react';
import { NotificationType } from '@ssar-app/domain';

export const NotificationMessage = (props: NotificationStepsProps) => {
  const { notification } = props;

  return (
    <Flex direction='column' minW='sm' mr='6'>
      <VStack alignItems='start' mb='6'>
        <Text fontSize='lg' fontWeight='semibold'>
          Step 3: Review & Submit
        </Text>
        <Text fontSize='sm'>Review the message and publish settings here</Text>
      </VStack>
      <Grid gap={6}>
        <GridItem>
          <Text fontSize='sm' mb={1}>
            Notification Type
          </Text>
          <Text fontSize='sm' fontWeight={'semibold'}>
            {notification.type}
          </Text>
        </GridItem>
        {notification.type !== NotificationType.MAINTENANCE && (
          <GridItem>
            <Text fontSize='sm' mb={1}>
              Product Selected
            </Text>
            <Text fontSize='sm' fontWeight={'semibold'}>
              {notification.productName}
            </Text>
          </GridItem>
        )}
        <GridItem>
          <Text fontSize='sm' mb={1}>
            Title
          </Text>
          <Text fontSize='sm' fontWeight={'semibold'}>
            {notification.title}
          </Text>
        </GridItem>
        <GridItem>
          <Text fontSize='sm' mb={1}>
            Message
          </Text>
          <Text fontSize='sm' fontWeight={'semibold'}>
            {getDescription(notification)}
          </Text>
        </GridItem>
        <GridItem>
          <Text fontSize='sm' mb={1}>
            Publish Date & Time
          </Text>
          <Text fontSize='sm' fontWeight={'semibold'} mb={4}>
            This notification will be published on{' '}
            {getPublishTime(notification)}.
          </Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};
